import { render, staticRenderFns } from "./faqcat.vue?vue&type=template&id=3960a6d4&"
import script from "./faqcat.vue?vue&type=script&lang=ts&"
export * from "./faqcat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3960a6d4')) {
      api.createRecord('3960a6d4', component.options)
    } else {
      api.reload('3960a6d4', component.options)
    }
    module.hot.accept("./faqcat.vue?vue&type=template&id=3960a6d4&", function () {
      api.rerender('3960a6d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/faq/faqcat.vue"
export default component.exports